import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SimpleContainerComponent} from './shared/layouts/simple-container/simple-container.component';
import {FullContainerComponent} from './shared/layouts/full-container/full-container.component';
import {AuthGuard} from './shared/guards/auth.guard';

const appRoutes: Routes = [
  {
    path: '', component: FullContainerComponent, canLoad: [AuthGuard], children: [
      {path: 'bids', loadChildren: './bids/bids.module#BidsModule'},
      {path: 'orders', loadChildren: './orders/orders.module#OrdersModule'},
      {path: 'partners', loadChildren: './partners/partners.module#PartnersModule'},
      {path: 'employees', loadChildren: './employees/employees.module#EmployeesModule'},
      {path: 'events', loadChildren: './events/events.module#EventsModule'},
      {path: 'transports', loadChildren: './transports/transports.module#TransportsModule'}
    ]
  },
  {path: 'auth', component: SimpleContainerComponent, loadChildren: './auth/auth.module#AuthModule'}
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRouting {
}



// WEBPACK FOOTER //
// D:/Projects/bid/frontend/src/app/app.routing.ts